import React from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css'; // Import Flatpickr styles
import './CTDatePickerRange.css'; // Import your custom styles

// Accept startDate, endDate, and onDateChange as props
const CTDatePickerRange = ({ value, onDateChange ,type,placeholder}) => {
  return (
    <div>
      <Flatpickr
        value={value} // Use props for value
        onChange={onDateChange} // Use prop for onChange handler
        options={{
          mode: type, // Enable range selection
          dateFormat: 'm/d/Y', // Set the date format
          locale: { firstDayOfWeek: 1 },
          maxDate: new Date(), // Start week on Monday
        }}
        className="flatpickr-input form-control" // Apply Bootstrap form control styles
        placeholder={placeholder} // Keep placeholder text
      />
    </div>
  );
};

export default CTDatePickerRange;
